export default __webpack_public_path__ + "static/media/1_0016.26a5dcb0.webp";